import { useState } from 'react';
import API_URL from '../config';

export const useChatbotDeuda = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const consultarDeuda = async (codigoMedidor, cedula) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/api/v2/public/consultar-deuda?codigoMedidor=${codigoMedidor}&cedula=${cedula}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'No se encontró información con los datos proporcionados');
      }
      
      return data; // { cliente: "...", empresa: "...", deudas: [...] }
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { consultarDeuda, loading, error };
};
